if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  setTimeout(() => {
    const observer = new MutationObserver((MutationList) => {
      for (let item of MutationList) {
        if (item.target.classList.contains("cart-drawer--recommendations")) {
          handleCartDrawerFooterMutation();
        }
        if (item.target.id === "Product-Drawer-Content") {
          document.dispatchEvent(new Event(`bss_b2b:QuickviewLoaded`));
        }
        if (
          item.target.classList.contains("product-sku") ||
          item.target?.lastElementChild?.className === "quantity buttons_added"
        ) {
          BSS_B2B.observer.productSubject.notifyObserver(
            "ProductMutate",
            "ProductPriceMutate"
          );
        }
        if (item.target.classList.contains("thb-cart-form")) {
          BSS_B2B.observer.cartSubject.listenCartCheckout();
        }
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }, 300);

  const translations = [
    {
      selector: ".bss-b2b-cart-item-qty-table-header span",
      original: "Rabattstaffel / Remise par quantité",
      translations: {
        en: "Show discount details based on quantity range",
        fr: "Afficher les détails de la remise selon la quantité",
      },
    },
    {
      selector: ".bss-b2b-qty-table-wrapper th:first-child",
      original: "Plage de quantités",
      translations: {
        en: "Quantity Range",
        fr: "Plage de quantités",
      },
    },
    {
      selector: ".bss-b2b-qty-table-wrapper th:last-child",
      original: "Rabatt / Remise",
      translations: {
        en: "Discount",
        fr: "Remise",
      },
    },
  ];

  function applyTranslations() {
    const locale = Shopify && Shopify.locale ? Shopify.locale : "en";

    translations.forEach((item) => {
      const el = document.querySelector(item.selector);
      if (el && item.translations[locale]) {
        el.textContent = item.translations[locale];
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    setTimeout(applyTranslations, 1500);
  });

  async function handleCartDrawerFooterMutation() {
    if (BSS_B2B) {
      const res = await BSS_B2B.storage.productStorage.load();
      if (res) {
        if (
          res.notExistProductIds?.length ||
          res.productIds?.length ||
          res.variantIds?.size
        ) {
          BSS_B2B.observer.productSubject.notifyObserver(
            "LazyProduct",
            "LoadedLazyProduct",
            {
              ...res,
            }
          );
        }
      }
    }
  }
}
